import { FC } from 'react';
import { SpaceshipSVG } from '@/assets/icons/spaceship/spaceship.component';
import '../../assets/icons/spaceship/spaceship.component.css';
import { SpaceshipLoaderProps } from './spaceship-loader-types';

export const SpaceshipLoader: FC<SpaceshipLoaderProps> = ({ 
  height = '200px', 
  className = '',
  maxWidth = '300px',
}) => {
  return (
    <div 
      className={`skeleton-container ${className}`}
      style={{ 
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        maxWidth,
        background: 'transparent',
        borderRadius: '8px'
      }}
    >
      <SpaceshipSVG />
    </div>
  );
};